import IconElectric from "../Components/Svg/IconElectric.vue";
import IconFuel from "../Components/Svg/IconFuel.vue";
import IconTransmissionManual from "../Components/Svg/IconTransmissionManual.vue";
import IconTransmissionAutomatic from "../Components/Svg/IconTransmissionAutomatic.vue";
import IconSedan from "../Components/Svg/Bodywork/IconSedan.vue";
import IconHatchback from "../Components/Svg/Bodywork/IconHatchback.vue";
import IconStation from "../Components/Svg/Bodywork/IconStation.vue";
import IconMpv from "../Components/Svg/Bodywork/IconMpv.vue";
import IconSuv from "../Components/Svg/Bodywork/IconSuv.vue";
import IconBus from "../Components/Svg/Bodywork/IconBus.vue";
import IconTruck from "../Components/Svg/Bodywork/IconTruck.vue";

export default {
    methods: {
        getIcon(id) {
            switch (id) {
                case 'electric':
                    return IconElectric;
                case 'petrol':
                case 'diesel':
                case 'fuel':
                    return IconFuel;
                case 'manual':
                    return IconTransmissionManual;
                case 'automatic':
                    return IconTransmissionAutomatic;
                case 'hatchback':
                    return IconHatchback;
                case 'sedan':
                    return IconSedan;
                case 'station':
                    return IconStation;
                case 'mpv':
                    return IconMpv;
                case 'suv':
                    return IconSuv;
                case 'bus':
                    return IconBus;
                case 'vrachtwagen':
                    return IconTruck;
                default:
                    return null;
            }
        }
    }
}
